const MOMENT_CUSTOMIZATIONS = {
  calendar : {
    lastDay : '[Yesterday at] LT',
      sameDay : '[Today at] LT',
      nextDay : '[Tomorrow at] LT',
      lastWeek : 'dddd [at] LT',
      nextWeek : 'dddd [at] LT',
      sameElse : 'LLL'
  }
};

/**
 * Sets the moment locale during a config block by looking at local preferences if available.
 */
export function configSetMomentLocale(moment, rnLocaleCookieProvider, rnLocalPreferences) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  // Look first to locale cookie for user's preferred language
  let preferredLocale = rnLocaleCookieProvider.getLocale();
  if (!preferredLocale) {
    // Fallback to local preferences
    preferredLocale = _.get(rnLocalPreferences(), 'general.locale');
  }

  if(preferredLocale) {
    preferredLocale = getSupportedLocale(preferredLocale);
    // Can't call angular-moment here, so call moment directly
    let momentLocaleName = moment.locale(preferredLocale);
    moment.updateLocale(momentLocaleName, MOMENT_CUSTOMIZATIONS);
  }
}

/**
 * Sets the angular moment locale when the locale is changed
 * by listening for angular-translate events.
 */
export function runSetMomentLocale($translate, $rootScope, amMoment, moment) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  $rootScope.$on('$translateChangeSuccess', function() {
    let locale = $translate.use();
    locale = getSupportedLocale(locale);
    // Call angular-moment for proper eventing
    let momentLocaleName = amMoment.changeLocale(locale);
    moment.updateLocale(momentLocaleName, MOMENT_CUSTOMIZATIONS);
  });
}

function getSupportedLocale(locale) {
  // moment.js doesn't currently support 'zh-HANS', need to specify the more specific variant of 'zh-cn'.
  if(locale === 'zh-HANS') {
    locale = 'zh-cn';
  }

  return locale;
}
